
module.exports = {
  brand: function(d) { return "THE OUTNET"; },
  contact: {
    title: function(d) { return "هل تحتاجينَ للمساعدة؟"; },
    copyBeforeLink: function(d) { return "لأي استفسارات ، يرجى زيارة"; },
    copyAfterLink: function(d) { return " لدى THE OUTNET"; },
    href: function(d) { return "/page/help/returns/"; },
    customerCare: function(d) { return "قسم خدمة العملاء"; }
  },
  search: {
    text: function(d) { return "ابحثوا عن THE OUTNET"; },
    clear: function(d) { return "إزالة"; },
    categories: function(d) { return "الفئات"; },
    designers: function(d) { return "المصممين"; },
    products: function(d) { return "المنتجات"; },
    colours: function(d) { return "الألوان"; },
    cta: function(d) { return "البحث"; },
    noResult: function(d) { return "لم نعثر على نتيجة لـ " + d.searchTerm; },
    tryAgain: function(d) { return "يُرجى المحاولة لاحقًا"; },
    loading: function(d) { return "جاري البحث"; },
    viewAll: function(d) { return "عرض جميع النتائج"; }
  },
  price: {
    discountPercentage: function(d) { return "(-%" + d.discountPercentage + ")"; },
    discountPrice: function(d) { return "سعر الخصم"; },
    currencyExchange: function(d) { return "(" + d.exchangeCurrency + " " + d.exchangePrice + " سعر الصرف)"; },
    wasPriceOriginal: function(d) { return "سعر التجزئة الموصى به: " + d.wasPrice; },
    wasPrice: function(d) { return "سعر التجزئة الموصى به:"; },
    originalPrice: function(d) { return "السعر الأصلي:"; }
  },
  localeSwitch: {
    languages: {
      en: function(d) { return "English"; },
      ar: function(d) { return "اللغة العربية"; },
      de: function(d) { return "Deutsch"; },
      fr: function(d) { return "française"; },
      ja: function(d) { return "日本語"; },
      ko: function(d) { return "한국어"; }
    },
    changeCountry: {
      title: function(d) { return "تغير المنطقة"; },
      description: function(d) { return "للحصول على أفضل ما في موقع THE OUTNET، تأكدوا من اختيار موقعكم من القائمة أدناه"; }
    },
    itemsUnavailable: {
      title: function(d) { return "قطع غير متاحة"; },
      description: function(d) { return "للأسف، واحدة أو بعض من القطع الموجودة في حقيبتك غير متوفرة في هذه الدولة. سنضطر لإزالة هذه القطع من حقيبتك في حال تغيير دولتك."; },
      confirmation: function(d) { return "التأكيد على تغيير الدولة"; },
      addToWishlist: function(d) { return "إضافة قطع إلى قائمة الأمنيات"; }
    }
  },
  cookieBanner: {
    title: function(d) { return "ملفات تعريف الارتباط والخصوصية"; },
    message: function(d) { return "يستخدم lموقعنا ملفات تعريف الارتباط، حتى من قبل الأطراف الخارجية. عند استمراركم بالتصفح، فإنكم توافقون على "; },
    cta: function(d) { return "سياسة ملفات تعريف الارتباط"; },
    href: function(d) { return "/الصفحة/المساعدة/سياسة ملفات تعريف الارتباط"; }
  },
  nav: {
    myAccount: {
      text: function(d) { return "مرحبًا، " + d.name; },
      href: function(d) { return "/account"; }
    },
    myAccountMobile: {
      text: function(d) { return "حسابك"; }
    },
    signIn: {
      text: function(d) { return "تسجيل الدخول"; },
      href: function(d) { return "/account/login"; }
    },
    signOut: {
      text: function(d) { return "تسجيل الخروج"; },
      href: function(d) { return "/account/login"; }
    },
    account: {
      text: function(d) { return "حسابك"; },
      href: function(d) { return "/account"; }
    },
    wishlist: {
      text: function(d) { return "قائمة الأمنيات"; },
      href: function(d) { return "/account/wishlist"; }
    },
    checkout: {
      text: function(d) { return "الدفع"; },
      href: function(d) { return "/checkout"; }
    },
    register: {
      text: function(d) { return "التسجيل"; },
      href: function(d) { return "/account/login"; }
    }
  },
  courtesyNav: {
    customerServiceInfo: {
      text: function(d) { return "خدمة العملاء"; },
      href: function(d) { return "/page/help/contact-us"; }
    },
    deliveryInfo: {
      text: function(d) { return "توصيل"; },
      href: function(d) { return "/page/help/customer-service/delivery"; }
    },
    returnsInfo: {
      text: function(d) { return "الإرجاع"; },
      href: function(d) { return "/page/help/customer-service/returns"; }
    },
    myOrders: {
      text: function(d) { return "طلبيّاتك"; },
      href: function(d) { return "/account/orders"; }
    },
    trackOrder: {
      text: function(d) { return "تتبّع طلبيّتك"; },
      href: function(d) { return "/account/track-order"; }
    },
    createReturn: {
      text: function(d) { return "إنشاء طلب إرجاع"; },
      href: function(d) { return "/account/create-return"; }
    }
  },
  copyright: {
    yearFrom: function(d) { return "2009- "; },
    copy: function(d) { return "،جزء من مجموعة YOOX NET-A-PORTER"; },
    extraCopy: function(d) { return "لا يعني ظهور الشخصيات المعروضة على هذا الموقع أنها توصي بموقع THE OUTNET أو بالمنتجات المعروضة عليه."; }
  },
  social: {
    title: function(d) { return "ابقوا على تواصل"; }
  },
  externalLinks: {
    mrp: function(d) { return "https://www.mrporter.com/"; },
    nap: function(d) { return "https://www.net-a-porter.com/"; }
  },
  error: {
    megaNav: function(d) { return "نعتذر! لم يتم العثور على تلك القائمة"; }
  },
  checkout: {
    copy: function(d) { return "الدفع الآمن"; }
  },
  footer: {
    footerLinks: function(d) { return "المساعدة والمعلومات"; },
    contactAndLocale: function(d) { return "تتوفّر خدمة العملاء على مدار 24 ساعة"; },
    signupAndSocial: function(d) { return "ابقوا على تواصل"; }
  },
  fastUserRegistration: {
    heading: function(d) { return "هل تريدون الاطلاع أولاً بأول على أحدث القطع الأنيقة؟"; },
    description: function(d) { return "اشتركوا في موقع THE OUTNET للحصول على خصم إضافي بنسبة 15% على طلبكم التالي! كما ستكونون أول من يعلم عن قطعنا الحصرية التي وصلت حديثًا وعن آخر صيحات الموضة والعروض القادمة. "; },
    exclusionsText: function(d) { return "تُطبق الاستثناءات –  تحقق من  الشروط والأحكام هنا"; },
    exclusionsLink: function(d) { return "https://www.theoutnet.com/page/policies/general-terms-and-conditions-of-sale/#promotional-codes"; },
    subscribe: function(d) { return "سارعوا بالاشتراك"; },
    placeholder: function(d) { return "يُرجى إدخال عنوان بريدكم الإلكتروني"; },
    sucessfulEmailMessage: function(d) { return "شكرًا، لقد تم تسجيلك لاستقبال رسائل البريد الإلكتروني الخاصّة بنا!"; },
    NoEmailMessage: function(d) { return "أدخلوا عنوان البريد الإلكتروني"; },
    invalidEmailMessage: function(d) { return "عنوان بريد إلكتروني غير صحيح"; }
  },
  seoMeta: {
    title: function(d) { return "خصم الأزياء المصممة| خصومات تصل إلى 70% على موقع THE OUTNET"; },
    description: function(d) { return "ويضمن لكم موقع THE OUTNET الارتقاء بأناقتكم إلى مستوى جديد بأحدث التصاميم التي تصل في أيام الاثنين والثلاثاء والخميس والجمعة من كل أسبوع."; }
  },
  webpush: {
    title: function(d) { return "هل تريدون أن تكونوا أول من يسمع عن أحدث عروضنا الترويجية وعن الخصومات لدينا؟"; },
    description: function(d) { return "سنرسل إليك إشعاراً حتى لا تفوتك الفرصة!"; },
    toggleMessage: function(d) { return "تفعيل إشعارات ويب بوش"; }
  },
  multishop: {
    mens: function(d) { return "الرجال"; },
    womens: function(d) { return "السيدات"; }
  },
  promptBasketItem: {
    title: function(d) { return "تم إضافة هذا المنتج إلى حقيبة التسوق"; },
    button: function(d) { return "متابعة إلى حقيبة التسوّق"; }
  }
}